import { merge } from 'lodash';
var bmActionColor = '#3899EC';
export var wixStyle = {
    palette: {
        actionColor: bmActionColor,
        bgColor: '#FFFFFF',
        textColor: '#000000',
    },
    paletteConfig: {
        focusActionColor: bmActionColor,
        settingsActionColor: bmActionColor,
    },
    settingsStyles: {
        buttons: {
            borderRadius: '18px',
            textColor: '#FFFFFF',
        },
        dividers: {
            color: '#DFE5EB',
        },
        icons: {
            color: '#32536A',
        },
        inputs: {
            borderColor: '#C1E4FE',
            borderRadius: '6px',
            placeholderColor: '#7A92A5',
        },
        text: {
            color: '#32536A',
            fontFamily: 'Madefor',
        },
        whitebox: {
            borderRadius: '8px',
            boxShadow: '0 8px 8px 0 rgba(22, 45, 61, 0.12), 0 3px 24px 0 rgba(22, 45, 61, 0.18)',
        },
    },
};
export var withWixStyle = function (theme) {
    return merge(wixStyle, theme || {});
};
//# sourceMappingURL=useWixStyle.js.map